"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestBindOperation = void 0;
var common_evm_utils_1 = require("@moralisweb3/common-evm-utils");
exports.requestBindOperation = {
    method: 'POST',
    name: 'requestBind',
    id: 'requestBind',
    groupName: 'evm',
    urlPathPattern: '/bind/request',
    bodyParamNames: ['addresses'],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams() {
    return {};
}
function getRequestBody(request, core) {
    return {
        addresses: request.addresses.map(function (address) { return ({
            blockchainType: address.blockchainType,
            address: common_evm_utils_1.EvmAddress.create(address.address, core).checksum,
        }); }),
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request, core) {
    return {
        addresses: request.addresses.map(function (address) { return ({
            blockchainType: address.blockchainType,
            address: common_evm_utils_1.EvmAddress.create(address.address, core).checksum,
        }); }),
    };
}
function deserializeRequest(jsonRequest, core) {
    return {
        addresses: jsonRequest.addresses.map(function (address) { return ({
            blockchainType: address.blockchainType,
            address: common_evm_utils_1.EvmAddress.create(address.address, core),
        }); }),
    };
}
//# sourceMappingURL=requestBindOperation.js.map